<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="title">3天CP·爱在进行时</div>
      <div class="declaration">
        希望你遇到一个清风明月般的人<br>不怕岁月蹉跎<br>不怕路途遥远<br>只要最后是你就好
      </div> -->
      <!-- <img class="pic-title" src="https://static.huiyiji520.com/cppic-1661943120.png">
      <img class="pic-declaration" src="https://static.huiyiji520.com/cppic-1661234545.png"> -->

      <div class="groupon-rule" v-if="groupon_capacity == 2">
        <div class="rule-title">双人拼团</div>
        <div class="rule-content">双人拼团，入场费用每人8折。</div>
        <div class="rule-content">拼团成员全部完成付款后，拼团成功，您将会收到报名资料填写链接，请务必完成填写。</div>
        <div class="rule-content hint">注：拼团优惠不可与其他代金券叠加使用</div>
      </div>

      <div class="groupon-rule" v-if="groupon_capacity == 3">
        <div class="rule-title">三人拼团</div>
        <div class="rule-content">三人拼团，标准入场/优先入场费用6折，超级入场费用8折。</div>
        <div class="rule-content">拼团成员全部完成付款后，拼团成功，您将会收到报名资料填写链接，请务必完成填写。</div>
        <div class="rule-content hint">注：拼团优惠不可与其他代金券叠加使用</div>
      </div>

      <div class="btn flex-box" @click="showPayPop()">参与拼团</div>
      <div class="btn flex-box modify" @click="goBack()">返回修改</div>

      <!-- <div class="instruction flex-box">
        <van-checkbox class="checkbox" v-model="checked" shape="square" icon-size="13">我已阅读并同意</van-checkbox>
        <div class="instruction-hint">
          <span class="instruction-title" @click="goUserProtocal()">《用户协议》</span>、<span class="instruction-title" @click="goPrivacyRule()">《隐私及个人信息指引》</span>
        </div>
      </div> -->

      <van-popup v-model="loading" class="pop-loading">
        <div class="loading">
          <span>正在拼命加载中，请稍等片刻～</span>
          <van-loading type="spinner" />
        </div>
      </van-popup>

      <van-popup class="pop-pay" v-model="showPayItems" position="bottom">
        <div>
          <div class="payway-title">选择入场方式</div>
          <div>
            <div class="price-item flex-box" :style="{'background': getPayItemBackground('basic'), 'borderColor': getBorderColor('basic')}" @click="pickPayItem('basic')">
              <div class="flex-box">
                <div :style="{'color': getPayPriceColor('basic')}">标准入场：<span class="discount-price">{{priceBasic}}</span></div>
                <div class="tags flex-box">
                  <div v-if="gender == 'male'" class="tag origin-fee" :style="{'color': getPayTagColor('basic'), 'borderColor': getPayTagBorderColor('basic')}"><span class="origin-price">原价49.9</span></div>
                  <div v-if="gender == 'female'" class="tag origin-fee" :style="{'color': getPayTagColor('basic'), 'borderColor': getPayTagBorderColor('basic')}"><span class="origin-price">原价29.9</span></div>

                  <div class="tag" :style="{'color': getPayTagColor('basic'), 'borderColor': getPayTagBorderColor('basic')}">标准模式</div>
                </div>
              </div>
              <img class="icon-check" v-if="!checkedPayBasic" src="https://static.huiyiji520.com/icon-circle-c0bebe-1667907777.png">
              <img class="icon-check" v-if="checkedPayBasic" src="https://static.huiyiji520.com/icon-check-eb8e80-1667907921.png">
            </div>
            <div class="price-item flex-box" :style="{'background': getPayItemBackground('prior'), 'borderColor': getBorderColor('prior')}" @click="pickPayItem('prior')">
              <div class="flex-box">
                <div :style="{'color': getPayPriceColor('prior')}">优先入场：<span class="discount-price">{{pricePrior}}</span></div>
                <div class="tags flex-box">
                  <div v-if="gender == 'male'" class="tag origin-fee" :style="{'color': getPayTagColor('prior'), 'borderColor': getPayTagBorderColor('prior')}"><span class="origin-price">原价59.9</span></div>
                  <div v-if="gender == 'female'" class="tag origin-fee" :style="{'color': getPayTagColor('prior'), 'borderColor': getPayTagBorderColor('prior')}"><span class="origin-price">原价39.9</span></div>

                  <div class="tag" :style="{'color': getPayTagColor('prior'), 'borderColor': getPayTagBorderColor('prior')}">优先匹配</div>
                  <div class="tag" :style="{'color': getPayTagColor('prior'), 'borderColor': getPayTagBorderColor('prior')}">98%匹配率</div>
                </div>
              </div>
              <img class="icon-check" v-if="!checkedPayPrior" src="https://static.huiyiji520.com/icon-circle-c0bebe-1667907777.png">
              <img class="icon-check" v-if="checkedPayPrior" src="https://static.huiyiji520.com/icon-check-eb8e80-1667907921.png">
            </div>
            <div class="price-item flex-box" :style="{'background': getPayItemBackground('membership'), 'borderColor': getBorderColor('membership')}" @click="pickPayItem('membership')">
              <div>
                <div class="flex-box">
                  <div :style="{'color': getPayPriceColor('membership')}">超级入场：<span class="discount-price">{{priceMembership}}</span></div>
                  <div class="tags flex-box">
                    <div v-if="gender == 'male'" class="tag origin-fee" :style="{'color': getPayTagColor('membership'), 'borderColor': getPayTagBorderColor('membership')}"><span class="origin-price">原价159</span></div>
                    <div v-if="gender == 'female'" class="tag origin-fee" :style="{'color': getPayTagColor('membership'), 'borderColor': getPayTagBorderColor('membership')}"><span class="origin-price">原价99</span></div>

                    <div class="tag" :style="{'color': getPayTagColor('membership'), 'borderColor': getPayTagBorderColor('membership')}">优先匹配</div>
                    <div class="tag" :style="{'color': getPayTagColor('membership'), 'borderColor': getPayTagBorderColor('membership')}">可参加3期</div>
                  </div>
                </div>
                <div class="price-remark" :style="{'color': getPayPriceColor('membership')}">• 可以参加3期活动，每期都享有优先匹配权，剩余未使用期数随时可退。</div>
              </div>
              <img class="icon-check" v-if="!checkedPayMember" src="https://static.huiyiji520.com/icon-circle-c0bebe-1667907777.png">
              <img class="icon-check" v-if="checkedPayMember" src="https://static.huiyiji520.com/icon-check-eb8e80-1667907921.png">
            </div>
          </div>
          <div class="pay-confirm" @click="payConfirm()">确认并支付</div>
        </div>
      </van-popup>

      <van-popup v-model="showCoupon" class="coupon-popup">
        <div class="coupon">
          <div class="coupon-reveiver">
            <div class="coupon-title">新人优惠券</div>
            <!-- <div class="coupon-price">¥ <span class="num">10</span></div> -->
            <div class="coupon-price"><span class="num">随机立减</span></div>
            <div class="coupon-hint">适用于：3天CP第{{$store.state.issue}}期</div>
            <div class="coupon-validity">有效期至：{{ $store.state.timePayDeadline }}</div>
            <div class="coupon-button" @click="activeCoupon()">立即领取</div>
          </div>
        </div>
      </van-popup>

    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Toast, Popup, Checkbox, Loading, Icon } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Loading.name]: Loading,
    [Icon.name]: Icon
  },
  data(){
    return {
      showPop: false,
      checked: true,
      loading: false,
      showPayItems: false,
      checkedPayBasic: false,
      checkedPayPrior: false,
      checkedPayMember: false,
      pickedPayItems: [],
      priceBasic: 39.9,
      pricePrior: 49.9,
      priceMembership: 129,
      groupon_capacity: this.$store.state.groupinfo.capacity,
      groupon_status: 0,
      showCoupon: false,
      couponClicked: false,
      gender: ''
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goUserProtocal(){
      this.handleRouter('/rules_user_protocal')
    },
    goPrivacyRule(){
      this.handleRouter('/rules_privacy')
    },
    showPayPop(){
      if(!this.checked){
        Toast('请先同意《用户协议》')
      }else if(this.$store.state.userinfo.paid == 0){
        this.loading = true
        let openid = this.$store.state.userinfo.openid
        this.$api.get('/couple/check_user_cp_limit', {openid: openid}, res => {
          if(res.code == 200){
            if(res.limit == 0){
              this.loading = false
              this.showPayItems = true
            }else{
              // this.submitFree()
              this.loading = false
              Toast('超级用户无需拼团，请通过单人报名链接提交表单')
            }
          }else{
            Toast('网络异常，请稍后再试～')
          }
        })
      }else{
        // this.submit()
        Toast('已有本期活动付款记录！')
      }
    },
    payConfirm(){
      if( this.pickedPayItems.length == 0 ){
        Toast('请选择入场方式')
      }else{
        this.submit()
      }
    },
    submit(){
      // Toast('报名时间已截止，下次早点来哦～')
      if(this.loading){
        return
      }else if(!this.checked){
        Toast('请先同意《用户协议》')
      }else if(this.$store.state.userinfo.paid == 1){
        Toast('已有本期活动付款记录！')
      }else{
        this.loading = true
        let openid = this.$store.state.userinfo.openid
        let cpchoose = this.$store.state.cpchoose
        let level = this.pickedPayItems[0]
        let groupon_uid = this.$store.state.groupinfo.groupon_uid
        if(!cpchoose.mySex){
          Toast('未选择你的性别')
          return
        }
        this.$api.post('/groupon/join_groupon', {
          openid: openid, sex: cpchoose.mySex, level: level, groupon_uid: groupon_uid
        }, res => {
         if(res.code == 200){
           // console.log('res :' + res)
           this.loading = false
           let _this = this
           wx.chooseWXPay({
             timestamp: res.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
             nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
             package: res.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
             signType: res.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
             paySign: res.paySign, // 支付签名
             success: function (payRes) {
               // 支付成功后的回调函数
               // alert("pay success: " + JSON.stringify(payRes));
               _this.$store.commit('updatePayStatus', { paid: 1 })
               _this.$store.commit('updateCpChooseFid', { fid: res.fid })
               // Toast('fid: ' + res.fid)
               // _this.$store.commit('updatSubmitted', { submitted: 1 })
               _this.showPayItems = false
               _this.$router.replace(`/groupon_invite_postcard/${groupon_uid}`)
             },
             fail: function (payErr){
               // alert("pay fail: " + JSON.stringify(payErr));
               // alert("pay res: " + JSON.stringify(res))
             }
           })
         }else{
           this.loading = false
           Toast(res.msg)
           this.$router.replace('/')
         }
        })
      }
    },
    wxConfigInit(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/couple/get_wx_js_config_couple', {url: window.location.href, openid: openid}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
          });
        }
      })
    },
    goLangClub(){
      let url = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg5Njg0MjQyMA==&scene=123#wechat_redirect"
      window.location.href = url
    },
    getPayItemBackground(level){
      return this.pickedPayItems.includes(level) ? '#f8e5e3' : '#f7f7f7'
    },
    getBorderColor(level){
      return this.pickedPayItems.includes(level) ? '#eb8e80' : '#f7f7f7'
    },
    getPayPriceColor(level){
      return this.pickedPayItems.includes(level) ? '#eb705e' : '#737373'
    },
    getPayTagColor(level){
      return this.pickedPayItems.includes(level) ? '#eb8e80' : '#8d8b8b'
    },
    getPayTagBorderColor(level){
      return this.pickedPayItems.includes(level) ? '#eb8e80' : '#c0bebe'
    },
    pickPayItem(level){
      this.pickedPayItems.pop()
      this.pickedPayItems.push(level)
      if(level == "basic"){
        this.checkedPayBasic = true
        this.checkedPayPrior = false
        this.checkedPayMember = false
      }else if(level == "prior"){
        this.checkedPayBasic = false
        this.checkedPayPrior = true
        this.checkedPayMember = false
      }else if(level == "membership"){
        this.checkedPayBasic = false
        this.checkedPayPrior = false
        this.checkedPayMember = true
      }
    },
    getEntryPrice(){
      let gender = this.$store.state.cpchoose.mySex
      this.gender = gender
      let openid = this.$store.state.userinfo.openid
      let capacity = this.$store.state.groupinfo.capacity
      // capacity = {"two": 2, "three": 3}[capacity]
      let issue = this.$store.state.issue
      this.$api.get('/groupon/get_user_enroll_prices_for_groupon', {openid: openid, sex: gender, capacity: capacity, issue: issue}, res => {
        if(res.code == 200){
          this.priceBasic = res.prices.basic
          this.pricePrior = res.prices.prior
          this.priceMembership = res.prices.membership
          this.groupon_status = res.groupon_status
          if(gender == "male" && res.prices.newbee == 1 && this.couponClicked == false){
            this.showCoupon = true
          }
        }
      })
    },
    activeCoupon(){
      Toast('成功领取优惠券！')
      this.showCoupon = false
      this.couponClicked = true
    }
  },
  mounted(){
    this.wxConfigInit()
    this.getEntryPrice()
  },
  activated() {
    this.getEntryPrice()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background-image: url("https://static.huiyiji520.com/cppic-1661178636.png"); */
  background-image: url("https://static.huiyiji520.com/cppic-1661150074.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .title{margin-top:200px;margin-bottom:113px;font-size:70px;color:#eb8e80;}
.main .declaration{font-size:40px;line-height:80px;color:#737373;margin-bottom:113px;}
.main .pic-title{width:202px;height:65px;margin:0 auto;margin-top:150px;margin-bottom:120px;}
.main .pic-declaration{width:584px;height:342px;margin:0 auto;margin-bottom:110px;}
.main .btn{
  width:342px;height:90px;font-size:40px;border:5px solid #f1b8af;border-radius:30px;
  margin:0px auto;color:#ffffff;background:#f1b8af;justify-content:center;
}
.main .btn.modify{margin-top:53px;background:#fff;color:#eb8e80;}
.main .instruction{
  font-size:24px;color:#000;position:fixed;bottom:66px;padding:0px 15px;padding-left:30px;
  align-items:center;
}
/* .main .instruction .checkbox{margin-right:18px;} */
/* .main .instruction .instruction-hint{margin-left:15px;text-align: left;} */
.main .instruction .instruction-title{color:#eb8e80;}
.main .pop{width:600px;padding:50px;}
.main .pop .ptitle{font-size:78px;color:#eb8e80;margin-top:50px;}
.main .pop .pic-ptitle{width:276px;height:69px;margin:0 auto;margin-top:50px;}
.main .pop .qrcode{width:280px;display:block;margin:0 auto;margin-top:20px;margin-bottom:20px;}
.main .pop .hints{font-size:32px;color:#545454;}
.main .pop .hints .hint{margin-bottom:15px;}
.main .pop .hints .hint.small{font-size:24px;padding-top:5px;color:#737373;}
.main .pop .date{color:#eb8e80;font-weight:bold;}
.main .pop .account{color:#67a1f0;font-weight:bold;}
.main .pop .keyword{color:#eb8e80;}
.main .pop .btn-confirm{
  background:#f1b8af;color:#fff;font-size:32px;width:180px;margin:0 auto;padding:10px;
  border-radius:25px;margin-top:48px;font-weight:bold;
}
.main .pop-loading{width:70%;padding:20px;background:rgba(255,255,255,0);color:#fff;font-size:28px;}
.main .pop-pay{font-size:32px;padding:20px;color:#737373;font-weight:normal;}
.main .pop-pay .payway-title{margin-bottom:25px;}
.main .pop-pay .price-item{
  background:#f7f7f7;margin-bottom:25px;padding:25px 20px;color:#737373;font-size:28px;
  justify-content:space-between;border-radius:10px;border:4px solid #f7f7f7;
}
.main .pop-pay .price-item .discount-price{color:#eb705e;}
.main .pop-pay .price-item .icon-check{width:45px;height:45px;}
.main .pop-pay .tag{font-size:22px;margin-left:15px;background:#fff;color:#8d8b8b;padding:2px 8px;border-radius:10px;border:2px solid #c0bebe;}
.main .pop-pay .tag.origin-fee{border:none;background:none;}
.main .pop-pay .origin-price{text-decoration:line-through;}
.main .pop-pay .price-remark{font-size:20px;text-align:left;padding-right:20px;margin-top:10px;}
.main .pop-pay .pay-confirm{background:#eb8e80;color:#fbfbfb;padding:20px;border-radius:10px;}

.main .groupon-rule{width:80%;margin:0 auto;margin-bottom:100px;}
.main .groupon-rule .rule-title{
  font-weight:bold;color:#eb8e80;font-size:50px;
  margin-bottom:50px;margin-top:150px;
}
.main .groupon-rule .rule-content{
  text-align:left;font-size:40px;line-height:70px;color:#737373;margin-bottom:20px;
}
.main .groupon-rule .rule-content.hint{font-size:28px;}

.coupon-popup{
  width:454px;
  height:536px;
  background-color:rgba(0,0,0,0);
}
.coupon{
  background-image: url(https://static.langmanyuan.com/cp-coupon-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  width:100%;
  height:100%;
}
.coupon-reveiver{
  padding-top:80px;
  padding-left:80px;
  padding-right:80px;
}
.coupon-title{
  text-align:center;
  color:#666;
  font-size:24px;
}
.coupon-price{
  font-size:32px;
  color:#fe4e45;
  font-weight:bold;
}
.coupon-price .num{
  font-size:56px;
  margin-left:10px;
}
.coupon-hint{
  font-size:24px;
  color:#fe4e45;
  font-weight:lighter;
}
.coupon-validity{
  color:#ae0504;
  font-size:24px;
  margin-top:50px;
}
.coupon-button{
  background-image: linear-gradient(0deg,#ffc83a,#ffe900);
  color:#752528;
  padding:10px 0px;
  font-size:28px;
  margin-top:80px;
  border-radius:30px;
}
</style>
